import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Login from "./components/Login/Login";
import Inventario from "./pages/Inventario";
import Tienda from "./pages/Tienda";
import AdminDashboard from "./pages/AdminDashboard";
import Contabilidad from "./pages/Contabilidad";
import Pedidos from "./pages/Pedidos";
import Usuarios from "./pages/Usuarios";
import Actividades from "./pages/Actividades";
import TrabajadorDashboard from "./pages/TrabajadorDashboard";
import Domicilios from "./pages/Domicilios"; 
import GestionClientes from "./pages/GestionClientes";
import Comisiones from "./pages/Comisiones";
import ComisionesTrabajador from "./pages/ComisionesTrabajador";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [userName, setUserName] = useState("");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const auth = localStorage.getItem("isAuthenticated") === "true";
    const role = localStorage.getItem("userRole");
    const name = localStorage.getItem("username");
    const data = JSON.parse(localStorage.getItem("user")) || JSON.parse(localStorage.getItem("userData") || "null");

    if (auth && role) {
      setIsAuthenticated(auth);
      setUserRole(role);
      setUserName(name);
      setUserData(data);
    }
  }, []);

  const handleLogin = (user) => {
    setIsAuthenticated(true);
    setUserRole(user.rol);
    setUserName(user.nombre);
    setUserData(user);
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("userRole", user.rol);
    localStorage.setItem("username", user.nombre);
    localStorage.setItem("user", JSON.stringify(user)); // Almacenamos con clave "user"
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserRole("");
    setUserName("");
    setUserData(null);
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userRole");
    localStorage.removeItem("username");
    localStorage.removeItem("user");
    localStorage.removeItem("userData"); // Limpiamos ambas por compatibilidad
  };

  return (
    <Router>
      <Navbar
        isAuthenticated={isAuthenticated}
        onLogout={handleLogout}
        userRole={userRole}
        userName={userName}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Login" element={<Login onLogin={handleLogin} />} />

        {/* Rutas protegidas para admin */}
        <Route
          path="/admin"
          element={
            isAuthenticated && userRole === "admin" ? (
              <AdminDashboard />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />
        <Route
          path="/Usuarios"
          element={
            isAuthenticated && userRole === "admin" ? (
              <Usuarios />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />
        <Route
          path="/Contabilidad"
          element={
            isAuthenticated && userRole === "admin" ? (
              <Contabilidad />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />
        <Route
          path="/Actividades"
          element={
            isAuthenticated && userRole === "admin" ? (
              <Actividades />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />
        <Route
          path="/Domicilios"
          element={
            isAuthenticated && userRole === "admin" ? (
              <Domicilios />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />
        <Route
          path="/gestion-clientes"
          element={
            isAuthenticated && userRole === "admin" ? (
              <GestionClientes />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />

        {/* Ruta de Comisiones solo para admin */}
        <Route
          path="/Comisiones"
          element={
            isAuthenticated && userRole === "admin" ? (
              <Comisiones />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />

        {/* Ruta de Comisiones para trabajador */}
        <Route
          path="/mis-comisiones"
          element={
            isAuthenticated && (userRole === "admin" || userRole === "trabajador") ? (
              <ComisionesTrabajador userData={userData} />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />

        {/* Rutas protegidas para trabajadores y admin */}
        <Route
          path="/Pedidos"
          element={
            isAuthenticated && (userRole === "admin" || userRole === "trabajador") ? (
              <Pedidos userRole={userRole} />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />

        {/* Rutas generales */}
        <Route
          path="/Inventario"
          element={isAuthenticated ? <Inventario /> : <Navigate to="/Login" />}
        />
        <Route path="/Tienda" element={<Tienda />} />

        {/* Ruta protegida para trabajador */}
        <Route
          path="/Trabajador"
          element={
            isAuthenticated && userRole === "trabajador" ? (
              <TrabajadorDashboard />
            ) : (
              <Navigate to="/Login" />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;